import * as React from "react";
import { SetStateAction, Dispatch, } from "react";
import { FormComponentProps } from "antd/lib/form";
import { PbrInputDate } from 'src/components/common/PbrInputDate/PbrInputDate';
import * as moment from 'moment';
import { IPricingParametersCalculator } from "src/services/interfaces/calculator/IPricingParametersCalculator";

interface IDisbursementDateComponent {
  customClass?: string;
  disbursementDays?: number;
  pricingRequest: IPricingParametersCalculator;
  onChange: Dispatch<SetStateAction<Partial<IPricingParametersCalculator>>>;
}

export function DisbursementDateComponent(props: IDisbursementDateComponent & FormComponentProps) {

  return (
    <PbrInputDate
      disabled={false}
      className={props.customClass}
      name="disbursementDate"
      formWrapper={props.form}
      disabledDate={current => current && current < moment(new Date()).add(props.disbursementDays ? props.disbursementDays : 5, "days")} // disable last days and add X days from today
      formItemProps={{ label: "Data de Desembolso" }}
      placeholder={"Informe a data de Desembolso"}
      value={moment(props.pricingRequest?.disbursementDate)}
      onChange={e => props.onChange({ disbursementDate: moment(e) })}
      rules={[{ required: true, message: "Data de Desembolso é obrigatória" }]}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/PricingComponents/DisbursementDateComponent/DisbursementDateComponent.tsx